import {IconButton, Typography, useTransition} from '@yandex-delivery/blocks'
import {LeftArrowIcon} from '@yandex-delivery/blocks/icons'
import {logEvent} from '@yandex-delivery/modules/rum/event'
import {config} from 'src/shared/config'
import i18n from 'src/shared/i18n'
import {Brand} from 'src/shared/types'
import {isUsp, tagToUrl} from 'src/shared/utils'

import {classes} from './CompleteScreenAuth.classes'

const CompleteScreenAuth: React.FC = () => {
  const isUspService = isUsp()

  const getText = () => {
    if (isUspService) {
      return i18n.print('route_usp_order_complete', 'Яндекс Помощник: заказ завершён')
    }

    return config.brand === Brand.Yango ? i18n.print('yango_route_order_complete') : i18n.print('route_order_complete')
  }

  const text = getText()

  useTransition(() => Promise.resolve(logEvent('route_order_complete')))

  function handleBackPress() {
    window.taxiApp?.call('requestHideWebView', 'token', {})
  }

  // Show the back button only inside the native app webview context.
  // When window.taxiApp is absent (e.g. browser opened via Alice), the button
  // has no working action — hide it instead of rendering a non-functional control.
  const isNativeApp = Boolean(window.taxiApp)

  return (
    <div className={classes.root} data-screen="CompleteScreenAuth">
      {isNativeApp && (
        <div className={classes.backButtonContainer}>
          <IconButton
            className={classes.backButton}
            data-theme-invert
            onPress={handleBackPress}
            shape="circle"
            variant="floating"
          >
            <LeftArrowIcon />
          </IconButton>
        </div>
      )}

      <div className={`${classes.item} ${classes.illustration}`}>
        <div
          className={classes.illustrationImage}
          style={{backgroundImage: `url("${tagToUrl('delivery_timeline_delivery_finished')}")`}}
        />
        <Typography className={classes.illustrationText} thickness="bold" variant="title4">
          {text}
        </Typography>
      </div>
    </div>
  )
}

export default CompleteScreenAuth
